import { setFetchingCart } from "@/redux/slice/cart/slice";
import { handleServerCartResponse } from "@/redux/slice/cart/utils/handleServerCartResponse";
import { BuildClientPayload } from "@/components/common/types/BuildClientPayload";
import { ThunkResolvedStatus } from "@/libs/enum/ThunkResolvedStatus";
import { fetchCartV2, fetchCartV2Variables } from "@/components/graphql/types/fetchCartV2";
import { FETCH_CART_V2 } from "@/components/graphql/serverCartV2";
import { AppDispatch } from "@/redux/store";
import fetchTotalCartItemCount from "@/redux/slice/cart/utils/fetchCartCount";

type FetchServerCartInput = BuildClientPayload & {
  patientId: string;
  authToken: string;
};

export const fetchServerCart = async (fetchServerCartInput: FetchServerCartInput, dispatch: AppDispatch) => {
  const { patientId, apolloClient, authToken } = fetchServerCartInput;

  if (patientId) {
    dispatch(setFetchingCart(ThunkResolvedStatus.pending));
    await apolloClient
      .query<fetchCartV2, fetchCartV2Variables>({
        query: FETCH_CART_V2,
        variables: {
          patientId,
        },
        fetchPolicy: "no-cache",
      })
      .then(async (response) => {
        const fetchCartResponse = response?.data?.fetchCartV2;
        await handleServerCartResponse(fetchCartResponse, dispatch);
      })
      .then(() => {
        fetchTotalCartItemCount({ dispatch, authToken });
        dispatch(setFetchingCart(ThunkResolvedStatus.fulfilled));
      })
      .catch((fetchCartError) => {
        console.error("Failed to fetch server cart", fetchCartError);
        dispatch(setFetchingCart(ThunkResolvedStatus.rejected));
      });
  }
};
